export default function (context) {
    const $context = $(context);
    const $chosenCategory = $context.find('.object-choose-radio:checked');
    const $videoAndSoundTestSwitchContainer = $context.find('.videoAndSoundTestSwitchContainer');
    const hasTestEnabled = $chosenCategory.data('has-video-and-sound-test-enabled');

    $videoAndSoundTestSwitchContainer.toggleClass('hide', !hasTestEnabled);
}
